import { AlertService } from './../../../../widgets/entry-components/alert/services/alert.service';
import { PrevRouteService } from './../../../../routing/services/prev-route.service';
import { ChBaseComponent } from './../ch-base/ch-base.component';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'inc-ch-email',
  templateUrl: './ch-email.component.html',
  styleUrls: ['./ch-email.component.scss'],
})
export class ChEmailComponent extends ChBaseComponent implements OnInit {
  @Output() callSave = new EventEmitter<string>();

  constructor(
    prevRouteService: PrevRouteService,
    private alertService: AlertService,
    router: Router,
    storage: Storage
  ) {
    super(prevRouteService, router, storage);
  }

  ngOnInit() {
    this.reset();
  }

  reset(): void {
    this.form = this.resetForm();
    this.getPractitionerEmail();
  }

  resetForm(): FormGroup {
    return new FormGroup({
      email: new FormControl('')
    });
  }

  emailAlert() {
    this.alertService.presentChangeEmail(this.form.value.email, () => { this.save(); });
  }

  save() {
    this.setMustRelogin();
    if (this.form.valid) {
      this.callSave.emit(this.form.value.email);
    }
  }

  getPractitionerEmail() {
    this.storage.get('user').then((user) => {
      if (user) {
        this.form.controls.email.setValue(user.email);
      }
    });
  }
}
